import { useEffect } from 'react'
import {getAllContracts, getContractById, getListContracts, getListContractsProps, getListProps} from '../../../services/sBook/contract.service'
import { action_setContractPropListValues, action_setContractProps } from '../../../reducers/actions/KPI/actions';
import { useDispatch } from 'react-redux';
import { getContractByElementId } from '../../../services/sKPI/element.service';
import { isNullUndefinedOrEmpty } from '../../../common/Helpers';

const useGetContracts = (contracts, setContracts) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListContracts();
                const response = serviceResponse.data;
    
                if (response.succeeded) {
                    /*setContracts(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: response.data
                    }));*/
                    setContracts(response.data);
                }
                else {
                    /*setContracts(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: []
                    }));*/
                    setContracts([]);
                }
            }
            catch (error) {
                /*setContracts(prevState => ({
                    ...prevState,
                    fireUpdate: true,
                    data: []
                }));*/
                setContracts([]);
            }
        }
        
        if (contracts === null) {
            getData()
        }
    }, [contracts, setContracts]);
}

const useGetContractsMaintainer = (contracts, setContracts) => {    
    useEffect(() => { 
        const getData = async () => {
            try {
                const serviceResponse = await getAllContracts();
                const response = serviceResponse.data;
                const aux_array = [];

                if (response.succeeded) {
                    response.data.forEach(element => {
                        const code = element.code ?? '';
                        const name = element.name ?? '';

                        aux_array.push({
                            key: element.id,
                            text: `${code}${name ? ` - ${name}` : ''}`,

                            id: element.id,
                            name: element.name,
                            contractCode: code,
                            elementCode: code,
                            internalCode: code,
                            elementNemo: element.nemo
                        });
                    });
                }

                setContracts(aux_array);
            }
            catch (error) {
                setContracts([]);
            }
        };
        
        if (contracts === null) {
            getData();
        }
    }, [contracts, setContracts]);
};

const useGetContractsPropsMaintainer = (contractsProps) => {    
    const dispatch = useDispatch();

    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListContractsProps();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_setContractProps(response.data));
                }
                else {
                    dispatch(action_setContractProps([]));
                }
            } 
            catch (error) {
                dispatch(action_setContractProps([]));
            }
        }
        
        if (contractsProps === null) {
            getData()
        }
    }, [contractsProps]);
}

const useGetContractPropValues = (contractPropId, contractPropValues, listContractsPropValues, setContractPropValues, inputParam_IsDialogOpen) => {    
    const dispatch = useDispatch();

    useEffect(()=> { 
        const getData = async () => {
            try {
                let propValues = listContractsPropValues.filter(x => x.contractPropId === contractPropId);

                if (propValues.length > 0) {
                    setContractPropValues(propValues);
                }
                else {
                    setContractPropValues([{
                        id: -1,
                        contractPropId: contractPropId,
                        name: "",
                        cplCode: "",
                        description: "",
                    }]);
                }
            } 
            catch (error) {
                setContractPropValues([]);
            }
        }
        
        if (contractPropValues === null && listContractsPropValues !== null && contractPropId !== null && inputParam_IsDialogOpen == true) {
            getData()
        }
    }, [contractPropId, contractPropValues, listContractsPropValues, setContractPropValues, inputParam_IsDialogOpen]);
}

const useGetPropsMaintainer = (props) => {    
    const dispatch = useDispatch();

    useEffect(()=> { 
        const getData = async () => {
            try {
                let serviceResponse = await getListProps();
                const response = serviceResponse.data;

                if (response.succeeded) {
                    dispatch(action_setContractPropListValues(response.data));
                }
                else {
                    dispatch(action_setContractPropListValues([]));
                }
            } 
            catch (error) {
                dispatch(action_setContractPropListValues([]));
            }
        }
        
        if (props === null) {
            getData()
        }
    }, [props]);
}

const useGetContractById = (contractId, contract, setContract) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getContractById(contractId);
                const response = serviceResponse.data;

                if (response.succeeded) {
                    setContract(response.data);
                }
                else {
                    setContract({});
                }
            }
            catch (error) {
                setContract({});
            }
        }
        
        if (contract === null && contractId !== null) {
            getData()
        }
    }, [contractId, contract, setContract]);
}

const useGetContractByElementId = (elementId, contract, setContract, boardId, componentFilters, calendarOptions) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getContractByElementId(elementId);
                
                const response = serviceResponse.data;

                if (response.succeeded) {
                    if (!isNullUndefinedOrEmpty(response.data)) {
                        setContract(response.data);
                    }
                    else {
                        setContract({});
                    }
                }
                else {
                    setContract({});
                }
            }
            catch (error) {
                setContract({});
            }
        }
        
        if (contract === null && boardId !== null && elementId !== null && componentFilters !== null && calendarOptions !== null) {
            getData()
        }
    }, [elementId, contract, setContract, boardId, componentFilters, calendarOptions]);
}

export {
    useGetContracts,
    useGetContractsMaintainer,
    useGetContractsPropsMaintainer,
    useGetContractPropValues,
    useGetPropsMaintainer,
    useGetContractById,
    useGetContractByElementId
}